import { useState } from 'react'

/**
 * Custom hook to manage the state of the event preview modal.
 * @returns {{
 *   isOpen: boolean,
 *   openModal: () => void,
 *   closeModal: () => void,
 *   setIsOpen: (isOpen: boolean) => void
 * }} An object containing:
 *   - isOpen: Boolean indicating if the modal is open.
 *   - openModal: Function to open the modal.
 *   - closeModal: Function to close the modal.
 *   - setIsOpen: Function to directly set the modal open state.
 */
export const useEventPreviewModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)

  const closeModal = () => setIsOpen(false)

  return {
    isOpen,
    openModal,
    closeModal,
    setIsOpen
  }
}
